import { http } from '@/services/api';

export interface AddressNeighborhoodDTO {
  id: number;
  name: string;
  city_id: number;
  city_name?: string;
  uf?: string;
}

export interface ListNeighborhoodsParams {
  city_id?: number;
  uf?: string;
  search?: string;
  limit?: number; // 1..200
}

export async function listNeighborhoods(params: ListNeighborhoodsParams = {}): Promise<AddressNeighborhoodDTO[]> {
  const q = new URLSearchParams();
  if (params.city_id != null) q.set('city_id', String(params.city_id));
  if (params.uf) q.set('uf', params.uf);
  if (params.search) q.set('search', params.search);
  if (params.limit) q.set('limit', String(params.limit));
  return http.get<AddressNeighborhoodDTO[]>(`/address-neighborhoods/list?${q.toString()}`);
}

export async function getNeighborhood(id: number): Promise<AddressNeighborhoodDTO> {
  return http.get<AddressNeighborhoodDTO>(`/address-neighborhoods/${id}`);
}
